var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('OrderLeftTabs'),_c('OrderDialog'),_c('OrderRightTabs')],1),(_vm.userRoleId == 10)?_c('OrderListCenter'):(_vm.userRoleId != 11)?_c('OrderList'):_vm._e(),_c('MedpredOrdersToConfirm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }